import { render } from "./previously-completed.vue?vue&type=template&id=c3fb9378"
import script from "./previously-completed.vue?vue&type=script&lang=js"
export * from "./previously-completed.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__